import {extendTheme} from '@salesforce/retail-react-app/app/components/shared/ui';

import {overrides as baseOverrides} from '@amblique/base/app/theme';
import Alert from '@amblique/king-living/app/theme/components/base/alert';
import Button from '@amblique/king-living/app/theme/components/base/button';
import Checkbox from '@amblique/king-living/app/theme/components/base/checkbox';
import Link from '@amblique/king-living/app/theme/components/base/link';
import NumberInput from '@amblique/king-living/app/theme/components/base/number-input';
import Radio from '@amblique/king-living/app/theme/components/base/radio';
import RangeSlider from '@amblique/king-living/app/theme/components/base/range-slider';
import Select from '@amblique/king-living/app/theme/components/base/select';
import Slider from '@amblique/king-living/app/theme/components/base/slider';
import Tag from '@amblique/king-living/app/theme/components/base/tag';
import Textarea from '@amblique/king-living/app/theme/components/base/textarea';
import AddressAutocompleteUI from '@amblique/king-living/app/theme/components/project/address-autocomplete-ui';
import AnimatedHeroCopy from '@amblique/king-living/app/theme/components/project/animated-hero-copy';
import Award from '@amblique/king-living/app/theme/components/project/award';
import Blog from '@amblique/king-living/app/theme/components/project/blog';
import BlogCard from '@amblique/king-living/app/theme/components/project/blog-card';
import BlogHeading from '@amblique/king-living/app/theme/components/project/blog-heading';
import BlogList from '@amblique/king-living/app/theme/components/project/blog-list';
import BlogRelatedArticles from '@amblique/king-living/app/theme/components/project/blog-related-articles';
import Breadcrumbs from '@amblique/king-living/app/theme/components/project/breadcrumbs';
import Callout from '@amblique/king-living/app/theme/components/project/callout';
import CheckboxFilterPartial from '@amblique/king-living/app/theme/components/project/checkbox-filter-partial';
import Collections from '@amblique/king-living/app/theme/components/project/collections';
import Comparison from '@amblique/king-living/app/theme/components/project/comparison';
import DoubleImageCarousel from '@amblique/king-living/app/theme/components/project/double-image-carousel';
import EditorialCopy from '@amblique/king-living/app/theme/components/project/editorial-copy';
import EditorialFeature from '@amblique/king-living/app/theme/components/project/editorial-feature';
import Field from '@amblique/king-living/app/theme/components/project/field';
import FilterBar from '@amblique/king-living/app/theme/components/project/filter-bar';
import FilterFlyout from '@amblique/king-living/app/theme/components/project/filter-flyout';
import FormAuth from '@amblique/king-living/app/theme/components/project/form-auth';
import FullHeaderHero from '@amblique/king-living/app/theme/components/project/full-header-hero';
import FullScreenImageGallery from '@amblique/king-living/app/theme/components/project/full-screen-image-gallery';
import GalleryCarousel from '@amblique/king-living/app/theme/components/project/gallery-carousel';
import ProductImageGallery from '@amblique/king-living/app/theme/components/project/product-image-gallery';
import HeaderHero from '@amblique/king-living/app/theme/components/project/header-hero';
import Home from '@amblique/king-living/app/theme/components/project/home';
import HomepageBanner from '@amblique/king-living/app/theme/components/project/homepage-banner';
import HomepageHeroBanner from '@amblique/king-living/app/theme/components/project/homepage-hero-banner';
import Hotspot from '@amblique/king-living/app/theme/components/project/hot-spot';
import HotspotContent from '@amblique/king-living/app/theme/components/project/hotspot-content';
import IconExplainer from '@amblique/king-living/app/theme/components/project/icon-explainer';
import ImageTiles from '@amblique/king-living/app/theme/components/project/image-tiles';
import MegaMenu from '@amblique/king-living/app/theme/components/project/mega-menu';
import ModularPreview from '@amblique/king-living/app/theme/components/project/modular-preview';
import Newsletter from '@amblique/king-living/app/theme/components/project/newsletter';
import Account from '@amblique/king-living/app/theme/components/project/account';
import PageAuth from '@amblique/king-living/app/theme/components/project/page-auth';
import PageNotFound from '@amblique/king-living/app/theme/components/project/page-not-found';
import PasswordRequirements from '@amblique/king-living/app/theme/components/project/password-requirements';
import Progress from '@amblique/king-living/app/theme/components/project/process';
import ProductCard from '@amblique/king-living/app/theme/components/project/product-card';
import ProductDetail from '@amblique/king-living/app/theme/components/project/product-detail';
import ProductList from '@amblique/king-living/app/theme/components/project/product-list';
import ProductRange from '@amblique/king-living/app/theme/components/project/product-range';
import ProjectButton from '@amblique/king-living/app/theme/components/project/project-button';
import QuantityPicker from '@amblique/king-living/app/theme/components/project/quantity-picker';
import RangeSliderFilterPartial from '@amblique/king-living/app/theme/components/project/range-slider-filter-partial';
import CartFlyout from '@amblique/king-living/app/theme/components/project/cart-flyout';
import SearchForm from '@amblique/king-living/app/theme/components/project/search-form';
import SearchModal from '@amblique/king-living/app/theme/components/project/search-modal';
import ShopButton from '@amblique/king-living/app/theme/components/project/shop-button';
import ShopTheLook from '@amblique/king-living/app/theme/components/project/shop-the-look';
import Showroom from '@amblique/king-living/app/theme/components/project/showroom';
import ShowroomListHeader from '@amblique/king-living/app/theme/components/project/showroom-list-header';
import Showrooms from '@amblique/king-living/app/theme/components/project/showrooms';
import ContactSection from '@amblique/king-living/app/theme/components/project/contact-section';
import SingleShopTheLook from '@amblique/king-living/app/theme/components/project/single-shop-the-look';
import InlineSwatchCard from '@amblique/king-living/app/theme/components/project/inline-swatch-card';
import LocaleSelector from '@amblique/king-living/app/theme/components/project/locale-selector';
import SwatchCarousel from '@amblique/king-living/app/theme/components/project/swatch-carousel';
import SwatchListRow from '@amblique/king-living/app/theme/components/project/swatch-list-row';
import UGCCarousel from '@amblique/king-living/app/theme/components/project/ugc-carousel';
import VideoCarousel from '@amblique/king-living/app/theme/components/project/video-carousel';
import VideoCarouselWithCopyIcons from '@amblique/king-living/app/theme/components/project/video-carousel-with-copy-icons';
import WhySignUp from '@amblique/king-living/app/theme/components/project/why-sign-up';
import {contentfulStyles} from '@amblique/king-living/app/theme/contentful';

const {components: baseComponents, ...baseExtensions} = baseOverrides;

export const overrides = {
  ...baseExtensions,

  components: {
    ...baseComponents,
    ...contentfulStyles,

    // Base Components
    Alert,
    Button,
    Checkbox,
    Link,
    NumberInput,
    Radio,
    RangeSlider,
    Select,
    Slider,
    Tag,
    Textarea,

    // Project Components
    AddressAutocompleteUI,
    AnimatedHeroCopy,
    Award,
    Blog,
    BlogCard,
    BlogHeading,
    BlogList,
    BlogRelatedArticles,
    Breadcrumbs,
    Callout,
    CheckboxFilterPartial,
    Collections,
    Comparison,
    DoubleImageCarousel,
    EditorialCopy,
    EditorialFeature,
    Field,
    FilterBar,
    FilterFlyout,
    FormAuth,
    FullHeaderHero,
    FullScreenImageGallery,
    GalleryCarousel,
    ProductImageGallery,
    HeaderHero,
    Home,
    HomepageBanner,
    HomepageHeroBanner,
    Hotspot,
    HotspotContent,
    IconExplainer,
    ImageTiles,
    InlineSwatchCard,
    LocaleSelector,
    MegaMenu,
    ModularPreview,
    Newsletter,
    PageAuth,
    PageNotFound,
    Account,
    PasswordRequirements,
    Progress,
    ProductCard,
    ProductDetail,
    ProductList,
    ProductRange,
    ProjectButton,
    QuantityPicker,
    RangeSliderFilterPartial,
    CartFlyout,
    SearchForm,
    SearchModal,
    ShopButton,
    ShopTheLook,
    Showroom,
    ShowroomListHeader,
    Showrooms,
    ContactSection,
    SingleShopTheLook,
    SwatchCarousel,
    SwatchListRow,
    UGCCarousel,
    VideoCarousel,
    VideoCarouselWithCopyIcons,
    WhySignUp,
  },
};

export default extendTheme(overrides);
